import React from 'react';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import './OfflineBanner.css';

/**
 * Banner that shows when user goes offline
 * Automatically hides when back online
 */
const OfflineBanner = () => {
  const { isOnline, wasOffline } = useOnlineStatus();

  // Show "You're offline" banner
  if (!isOnline) {
    return (
      <div className="offline-banner offline">
        <div className="offline-banner-content">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 9L5 13L9 9M15 9L19 13L23 9M1 15L5 19L9 15M15 15L19 19L23 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="offline-banner-text">
            You're offline. Some features may be limited.
          </span>
        </div>
      </div>
    );
  }

  // Show "Back online" banner briefly after reconnecting
  if (wasOffline) {
    return (
      <div className="offline-banner online">
        <div className="offline-banner-content">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 13L9 17L19 7"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className="offline-banner-text">
            You're back online!
          </span>
        </div>
      </div>
    );
  }

  return null;
};

export default OfflineBanner;
